<script lang="ts" setup>
import { ref } from 'vue'  
import { useRouter } from 'vue-router'  
const router = useRouter()
const slideData = ref(
  {
    id: '01',
    title: '园区智服',
    txt1: '构建园区高效服务平台',
    txt2: '精选优质服务机构、本地化服务团队、智能化管理',
    imgs: 'https://static.idicc.cn/cdn/official/H5/park_top_bg.png',
  },
)

const jumpTo = () => {
  router.push({
    path: '/consultUsForm/report',
  })
}
</script>

<template>
  <div class="view-container">
    <div class="w-full h-full bg-cover  bg-center bg-no-repeat pt-[80px]" :style="{ backgroundImage: `url(${slideData.imgs})` }">
      <div class="mt-5 flex flex-col  w-full flex-wrap items-center justify-center">
          <div class="w-full ml-[32px]">
          <div class="flex items-center">
            <div class="text-[36px] text-[#333] font-bold">
              {{ slideData.title }}
            </div>
          </div>
          <div class="text-[24px] text-[#333] leading-[32px] mt-4">
            {{ slideData.txt1 }}
          </div>
          <div class="text-[24px] text-[#333] leading-[32px]">
            {{ slideData.txt2 }}
          </div>
          <div class="buttonTextIcon text-[26px] text-white text-center leading-[50px] mt-5" @click="jumpTo">
            立即咨询
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.view-container {
  position: relative;
  width: 100%;
  height: 420px;
}
.buttonTextIcon {
  width: 160px;
  height: 50px;
  background:bottom / contain no-repeat url("https://static.idicc.cn/cdn/official/H5/home_btn_bg.png");
  background-size:100% 100%;
}
</style>
